import React from 'react';
import PropTypes from 'prop-types';
import BaseContentForm from './BaseContentForm';

/**
 * CreateContentForm Component
 * Form for creating new content entries
 * 
 * @component
 */
function CreateContentForm({ 
  isOpen, 
  onClose, 
  onSubmit, 
  contentTypes, 
  defaultContentType,
  savedContents 
}) {
  const initialContent = {
    title: '',
    description: '',
    content: '',
    content_type: defaultContentType?.id ? parseInt(defaultContentType.id, 10) : '',
    state: 'Draft',
    contextReferences: []
  };

  const handleSubmit = (formData) => {
    const submissionData = {
      ...formData,
      content_type_id: parseInt(formData.content_type, 10),
      contextReferences: formData.contextReferences || []
    };
    onSubmit(submissionData);
  };

  return (
    <BaseContentForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      contentTypes={contentTypes}
      savedContents={savedContents}
      initialContent={initialContent}
      title="Create Content"
      submitButtonText="Create"
    />
  );
}

CreateContentForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  contentTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  defaultContentType: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired
  }),
  savedContents: PropTypes.array
};

export default CreateContentForm; 